export class StorageUtil {
    isJsonString(str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    }
  
    setStorage(name, data) {
      if (typeof data === 'object') data = JSON.stringify(data)
      localStorage.setItem(name, data)
    }
  
    getStorage(name) {
      if (typeof window !== 'undefined' && process.client) {
        const data = localStorage.getItem(name)
        return this.isJsonString(data) ? JSON.parse(data || '[]') : data
      }
    }
  
    removeStorage(name) {
      localStorage.removeItem(name)
    }
  
    getBets() {
      return this.getStorage('betslipSelections')
    }
  
    setBets(bets) {
      return this.setStorage('betslipSelections', bets)
    }
  
    setSessionStorage(name, data) {
      sessionStorage.setItem(name, data)
    }
  
    getSessionStorage(name) {
      if (typeof window !== 'undefined') {
        const data = sessionStorage.getItem(name)
        return data
      }
    }
  
    removeSessionStorage(name) {
      sessionStorage.removeItem(name)
    }
  
    setCookie(name, data, days) {
      if (typeof data === 'object') data = JSON.stringify(data)
      let expires = ''
      if (days) {
        const date = new Date()
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
        expires = '; expires=' + date.toUTCString()
      }
      document.cookie = name + '=' + (data || '') + expires + '; path=/'
    }
  
    getCookie(name) {
      if (document && document?.cookie) {
        const value = `; ${document?.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop().split(';').shift()
      }
    }
  
    removeCookie(name) {
      const date = new Date()
      date.setTime(date.getTime() + (-5 || 7) * 24 * 60 * 60 * 1000)
      const expires = date.toUTCString()
      document.cookie = `${name}='';samesite=None;secure=true expires=${expires}; path=/`
      // eslint-disable-next-line prefer-const
      let parts = location.hostname.split('.')
      // eslint-disable-next-line prefer-const, @typescript-eslint/no-unused-vars, no-unused-vars
      let subdomain = parts.shift()
      // eslint-disable-next-line prefer-const
      let upperleveldomain = parts.join('.')
      document.cookie = `${name}='';domain=${upperleveldomain}; expires=${expires}; path=/`
    }
  
    removeWildCardCookie(name) {
      const date = new Date()
      date.setTime(date.getTime() + (-5 || 7) * 24 * 60 * 60 * 1000)
      const expires = date.toUTCString()
      const parts = location.hostname.split('.')
      parts.shift()
      const upperleveldomain = parts.join('.')
      document.cookie = `${name}='';domain=${upperleveldomain}; expires=${expires}; path=/`
    }
  
    setWildCardCookie(name, data, days) {
      if (typeof data === 'object') data = JSON.stringify(data)
      let expires = ''
      // eslint-disable-next-line prefer-const
      let parts = location.hostname.split('.')
      // eslint-disable-next-line prefer-const, @typescript-eslint/no-unused-vars, no-unused-vars
      let subdomain = parts.shift()
      // eslint-disable-next-line prefer-const
      let upperleveldomain = parts.join('.')
      if (days) {
        const date = new Date()
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
        expires = ';expires=' + date.toUTCString()
      }
      document.cookie =
        name +
        '=' +
        (data || '') +
        expires +
        ';domain=' +
        upperleveldomain +
        ';path=/'
    }
  }
  